import { productCardType } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import { useLayoutContext } from '@/context/LayoutContext';
import Loader from '@/components/common/Loader';

export default function IncreaseDecreaseButtons({
  item,
  count,
  callback,
  fromBasket = true,
  className = '',
}: {
  item?: productCardType;
  count: number;
  fromBasket?: boolean;
  callback?: (value: number, x: string) => void;
  className?: string;
}) {
  const { changeBasketCount, checkIfLogin, loadingBasket } = useLayoutContext();
  return (
    <div className={`${styles.qty} ${styles.qty_sm} ${className}`}>
      <div
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.preventDefault();
          e.stopPropagation();
          // checkIfLogin &&
          //   checkIfLogin(() => {
          if (fromBasket) {
            changeBasketCount && item && changeBasketCount(item, 'remove', e);
          } else {
            if (count && count > 1) {
              callback && callback(count - 1, 'minus');
            }
          }
          // });
        }}
      >
        <MainIcons.minusIcon fill="var(--text-dark)" />
      </div>
      <span className={`${styles.mono}`}>
        {loadingBasket == item?.id ? (
          <Loader className={`${styles.loader}`} containerclassname={`${styles.loaderWrapper}`} />
        ) : (
          count
        )}
      </span>
      <div
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.preventDefault();
          e.stopPropagation();
          // checkIfLogin &&
          //   checkIfLogin(() => {
          if (fromBasket) {
            changeBasketCount && item && changeBasketCount(item, 'add', e);
          } else {
            callback && callback(count + 1, 'plus');
          }
          // });
        }}
      >
        <MainIcons.plusIcon fill="var(--text-dark)" />
      </div>
    </div>
  );
}
